import PrivacyPolicy1 from './PrivacyPolicy1'
export default PrivacyPolicy1
